import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import Icon from '../../icon/icon.component';
import { getInitialStyle, defaultContext, getContentAdvisoryIconStyle } from './contentAdvisory.style';

export class ContentAdvisory extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Label: {},
        Icons: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  set data({ icons, label }) {
    const { screenSize } = this._style;

    this.patch({
      Label: {
        visible: Boolean(label),
        text: {
          text: label,
        },
      },
      Icons: {
        visible: Boolean(icons.length),
        children: icons.map(icon => ({
          type: Icon,
          ...getContentAdvisoryIconStyle(icon, screenSize),
        })),
      },
    });
  }
}
